import axios from 'axios';
import { AuthService } from '~/store/ducks/Auth/services';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 1000 * 3600, // Wait for 3600 seconds
  headers: {
    common: {
      'Content-Type': 'application/json',
    },
  },
});

api.interceptors.request.use(
  (config) => {
    const token = AuthService.getToken();
    const username = AuthService.getUsername();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (username) {
      config.headers.username = username;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // No ambiente local, preserve a resposta para facilitar o diagnóstico.
      // Em dev, a autenticação é tratada pelo profile local do backend.
      if (process.env.NODE_ENV !== 'development') {
        window.location.href = '/logout';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
